import styled from 'styled-components'

import { icons } from '@/constants/icons'

export const DescWrapper = styled('div')<{
  $mobileStyle: boolean
  $selfServiceType?: boolean
}>`
  width: 380px;
  margin: ${(props) => (props.$selfServiceType ? '60px 0 0 0' : '0 0 0 40px')};
  padding-top: ${(props) => (props.$mobileStyle ? '98px' : '0px')};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: ${(props) => (props.$selfServiceType ? 'center' : 'flex-start')};
  text-align: ${(props) => (props.$selfServiceType ? 'center' : 'left')};
`
export const TitleElem = styled('div')`
  color: ${(props) => props.theme.colors.qrCode.title};
  font-size: 26px;
  line-height: 1;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 22px;
`
export const TextElemMain = styled('div')`
  color: ${(props) => props.theme.colors.qrCode.text};
  font-size: 22px;
  line-height: 1.5;
  margin-bottom: 22px;
  & span {
    display: block;
    color: ${(props) => props.theme.colors.qrCode.link};
  }
`
export const TextElem = styled('div')`
  color: ${(props) => props.theme.colors.qrCode.text};
  font-size: 18px;
  line-height: 1.5;
  margin-bottom: 12px;
  & span,
  & a {
    display: block;
    color: ${(props) => props.theme.colors.qrCode.link};
    pointer-events: all;
  }
`
export const Code = styled('div')`
  margin-bottom: 20px;
  font-weight: 500;
  font-size: 30px;
  line-height: 1;
  letter-spacing: 0.2em;
`
export const Expires = styled('div')`
  padding-left: 36px;
  font-weight: 500;
  font-size: 20px;
  line-height: 1.4;
  color: ${(props) => props.theme.colors.qrCode.text};
  background-image: url(${icons.register.clockIcon});
  background-repeat: no-repeat;
  background-position: 0 50%;
  background-size: 28px 28px;
  opacity: 0.4;
`
